import React, {useEffect, useRef, useState} from "react";
import {Button, Divider, Form, Input, message, Modal} from "antd";
import './Proceed.css';
import { useNavigate} from "react-router-dom";
import {CloseCircleFilled, ExclamationCircleFilled} from '@ant-design/icons';
import {SubmitNickNameRequestModel} from "../models/SubmitNickNameRequestModel";
import {SecondaryDeviceModel} from "../models/SecondaryDeviceModel";
import {submitNickNameRequest} from "../service/LoginService";
import ModalContent from "../../../constant/ModalContent";
import Indicator from "../../common/components/Indicator";
import Header from "../../../components/header/Header";



export default function Proceed() {

    const [nickName, setNickName] = useState("")
    const [visible, setVisible] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [isLoading,setIsLoading] = useState(false);
    const [random,setRandom]=useState(0);
    // const [logMessage, setLogMessage] = useState(LogContent.PROCEED_PAGE);

    const carrierPostData = localStorage.getItem("carrierPostData");
    const sessionId= localStorage.getItem("sessionId");

    // const isMountedRef = useRef(false);

    console.log(carrierPostData);
    console.log(sessionId);

    const navigate = useNavigate();

    const getUniqueId = () => {
        const min = 0;
        const max = 100;
        const rand = Math.floor(Math.random() * (max - min + 1) + min);
        setRandom(rand);
        return rand;
    };

    const openTermsAndCondition = (values) => {
        setVisible(true);
        setModalContent(
            <>
                <ExclamationCircleFilled />
                <h3>Terms and Conditions</h3>
                <div className="terms">
                    {ModalContent.TERMS_AND_CONDITION}
                </div>
                <br/>
                <Divider/>
                <Button
                    className="okButton"
                    type="text"
                    danger
                    onClick={() => handleSubmit(values)}
                    disabled={isLoading}
                >
                    OK
                </Button>
            </>
        )
        // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Terms and Conditions").replace("{{page}}", LogContent.PROCEED_PAGE));
        // isMountedRef.current = false;
    }

    const handleCancel = () => {
        setVisible(false);
        // setLogMessage(LogContent.PROCEED_PAGE);
        // isMountedRef.current = false;
    };

    const handleCancelWithCallback = () => {
        // eslint-disable-next-line no-undef
        DataActivationController.doneSelected()
        setVisible(false);
        // setLogMessage(LogContent.PROCEED_PAGE);
        // isMountedRef.current = false;
    };

    const handleSubmit = async (values) => {
        setIsLoading(true);

        const devices:SecondaryDeviceModel={
            eid:"",
            deviceType:"Watch",
            imei:""
        }
        const submitNickNameRequestModel:SubmitNickNameRequestModel = {
            "request-id": getUniqueId(),
            carrierPostData: carrierPostData,
            nickName: values.nickName,
            sessionId: sessionId,
            serviceType: "Multi-SIM",
            secondaryDevice:devices
        }
        console.log(submitNickNameRequestModel);
        try{
            const response = await submitNickNameRequest(submitNickNameRequestModel);
            setIsLoading(false);
            console.log(response);
            if(response.resultCode === 0){
                // const { mainUser, attachedUsers } = response;
                // console.log(mainUser);
                // console.log(attachedUsers);
                // const data = { mainUser, attachedUsers };
                // navigate("/home", { state: { data: data } });

                const {eid,iccid}=response;
                console.log(eid);
                console.log(iccid);

                navigate("/proceed/congrats", {state: {eid:eid,iccid:iccid}});
            }else if (response.resultCode === 6400) {
                setModalContent(
                    <>
                        <CloseCircleFilled/>
                        <h3>Invalid ID number</h3>
                        <div>
                            {ModalContent.INVALID_ID_NUMBER_MESSAGE}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancel}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Invalid ID number").replace("{{page}}", LogContent.PROCEED_PAGE));
                // isMountedRef.current = false;
            } else if (response.resultCode === 6401) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Not eligible for Apple Watch one number service</h3>
                        <div>
                            {ModalContent.NOT_ELIGIBLE_MESSAGE}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Not eligible for Apple Watch one number service").replace("{{page}}", LogContent.PROCEED_PAGE));
                // isMountedRef.current = false;
            } else if(response.resultCode===6402){
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Error Occurred!</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Error Occurred").replace("{{page}}", LogContent.PROCEED_PAGE));
                // isMountedRef.current = false;
            }else if(response.resultCode === 6403) {
                navigate("/");
                message.error(response.resultDesc, 1)
            }else if(response.resultCode === 6405) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Maximum Device Count Reached</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Maximum Device Count Reached").replace("{{page}}", LogContent.PROCEED_PAGE));
                // isMountedRef.current = false;
            }else if(response.resultCode === 6406) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Your account is blocked.</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Account Blocked").replace("{{page}}", LogContent.PROCEED_PAGE));
                // isMountedRef.current = false;
            }
        }catch(error){
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION,1);
            throw new Error(error);
        }
    }

    useEffect(() => {

        // if (!isMountedRef.current) {
        //     isMountedRef.current = true;
        //     const payload = {
        //         level: "INFO",
        //         timestamp: new Date().toISOString(),
        //         pageName: LogContent.PROCEED_PAGE,
        //         message: logMessage
        //     };
        //
        //     submitWebSheetLogCollection(payload)
        //         .then(() => {
        //             console.log('Log submitted successfully');
        //         })
        //         .catch(error => {
        //             console.error('Error submitting log:', error);
        //         });
        // }

    }, []);

    return(
        <div>
            <div style={{backgroundColor:"#E6E6E6",width:"100%"}}>
                <Header/>
            </div>

            {isLoading && <Indicator />}

            <Form
                className="form"
                onFinish={openTermsAndCondition}
            >
                <p className="para-title">
                    Add a name to identify your device
                </p>

                <Form.Item
                    name="nickName"
                    rules={[
                        {
                            required: true,
                            message: "Must Fill Nick Name"
                        },
                        {
                            pattern: /^[a-zA-Z0-9_]+$/,
                            message: "Nickname must contain only alphanumeric characters."
                        }
                        ]}
                >
                    <Input
                        placeholder="Nickname"
                        value={nickName}
                    />
                </Form.Item>

               <div className="terms">
                   <span className="termsOpacity">No extra charges. All usage will be charged to your primary mobile connection.</span>
                    <br/>
                    <br/>
                    <br/>
                   By clicking on "PROCEED" you are confirming your agreement to our <span className="termSpan">Terms and Conditions</span> of the multi-SIM service.
               </div>

                <Form.Item>
                    <Button
                        type="primary"
                        shape="round"
                        htmlType="submit"
                        className="mainButton"
                        style={{ backgroundColor: "#f13434"}}
                    >
                        PROCEED
                    </Button>
                </Form.Item>
            </Form>

            <Modal
                open={visible}
                onCancel={handleCancel}
                footer={null}
            >
                {modalContent}
            </Modal>


        </div>
    )
}